"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migrateCharPos = void 0;
/**
 * This migration got introduced because we were using an internal type in the game for character position
 * which is different from schema. They have now been sycned up
 */
const migrateCharPos = async (story) => {
    story.steps = story.steps.map((step) => {
        step.gestures = step.gestures.map((gesture) => {
            var _a;
            return ({
                ...gesture,
                charPos: {
                    charID: gesture.charID,
                    from: {
                        x: gesture.charPos.x,
                        y: gesture.charPos.y,
                    },
                    to: (_a = gesture.charMotion) === null || _a === void 0 ? void 0 : _a.to,
                    startsOut: false,
                    charMotion: gesture.charMotion,
                }
            });
        });
        return step;
    });
    return story;
};
exports.migrateCharPos = migrateCharPos;
//# sourceMappingURL=migrateCharPos.js.map